var customMain = {
    _helpers:{
        formatMoney: function (amount, decimalCount = 2, decimal = ',', thousands = '.') {
            try {
                decimalCount = Math.abs(decimalCount)
                decimalCount = isNaN(decimalCount) ? 2 : decimalCount

                const negativeSign = amount < 0 ? '-' : ''

                let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
                let j = (i.length > 3) ? i.length % 3 : 0

                return negativeSign + '$' + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
            } catch (e) {
                //console.log(e)
            }
        }
    },
    methods: {
      addToCart: function(){
          $(document).on('change', '[name="variant-selector-widget--radio"]', function(e){
              e.preventDefault();
              e.stopPropagation();
              var variant = !!$(this).attr('data-variant-object')? JSON.parse($(this).attr('data-variant-object').replace(/'/g,'"')):null
              var variantSelected = variant.id;
              // debugger;
              var variantSelectorReference = $(this).closest('form').find(`[variant-selector-reference=${$(this).attr('variant-selector-target')}]`)
              var ProductDiv = $(this).closest('.e-product__infos')
              $(variantSelectorReference).val(variantSelected)
              $(variantSelectorReference)
                  .trigger('click')
                  .trigger('change')
              $(`.e-product__photos--thumbs [data-image-variants="${variantSelected}"]`).click()
              $(ProductDiv).find('[variant-selected-price]').html(customMain._helpers.formatMoney(variant.price/100))
              // variant-selected-price
              // debugger;
          });
          $(document).on('click', '.ProductItem__buy', function(ev){
              // disable button buy
              $(this).attr('disabled', 'disabled');
              document.dispatchEvent(new CustomEvent("theme:loading:start"))
              
              var variantID = ev.currentTarget.dataset.id;
              // get value variant product id
              // var variation_id = $(this).data('id')
              //console.log(ev.currentTarget, variantID)
              var qtda_product = 1;
              
              // ADD TO CART
              let product = {
                  quantity: qtda_product,
                  id: variantID
              }
              
              $.ajax({
                  url: '/cart/add.js',
                  dataType: 'json',
                  type: 'post',
                  data: product,
                  success: function(response) {
                      document.dispatchEvent(new CustomEvent("theme:loading:end"))
                      //console.log('PRODUTO ADD TO CART');
                    	
                      document.dispatchEvent(new CustomEvent('product:added', {
                          bubbles: true,
                          detail: {
                              variant: response,
                              quantity: parseInt(qtda_product)
                          }
                      }))

                      setTimeout(function() {
                        Shopify.Cart.ShippingCalculator.show({
                            submitButton: "calculate", 
                            submitButtonDisabled: "calculating...",
                            moneyFormat: moneyformat
                        });
                      }, 2000);

                  }
              });
              
              // enable button buy
              $(this).removeAttr('disabled');
          });
          $(document).on('variant:changed', '.ProductItem__buy', function(ev){
              variant:changed
          });
      },

    	feedInsta: function(){
        window.feedHtml = '';
          
        var _token = $('.e-instagram[data-token]').data('token');
          
        if(!_token) {
          return;
        }
          
        function getInstagramItems(token,limit){
          $.ajax({
            url: 'https://graph.instagram.com/me/media?fields=id,media_type,media_url,permalink&access_token=' + token,
            type:'GET',
            success: function(resp){
              var totalItems = resp.data.length;

              var promises = [resp.data.forEach(function(item,index){
                setItemFeedInstagram(item,totalItems,index);
              })];

              Promise.all(promises).then(function(responseList){
                $('.e-instagram__content').append(window.feedHtml);
                $('.e-instagram__content').flickity({
                  contain: true,
                  pageDots: false,
                  freeScroll: true,
                  wrapAround: true,
                });
              })
            },
            error: function(resp){
              console.warn(resp.responseJSON)
            }
          })
        }

        function setItemFeedInstagram(item,total,index){
          var _html = '<div class="e-instagram__box">\n'
                  _html += '<a href="${linkUrl}" target="_blank" class="e-instagram__item">\n'
                     _html += '<img class="e-usebob-lazyload" data-src="${imgUrl}" width="278" height="346" alt="instagram-post">\n'
                     _html += '<div class="e-instagram__hover">\n'
                         _html += '<span class="e-instagram__hover--svg"></span>\n'
                      _html +='</div>\n'
                 _html +='</a>\n'
              _html +='</div>\n'
          if(item.media_type != 'IMAGE'){
              return false;
          }
          var _url = item.permalink;
          var _imgUrl = item.media_url;

          _html = _html.replace('${linkUrl}',_url);
          _html = _html.replace('${imgUrl}',_imgUrl);
          window.feedHtml += _html
          
          setTimeout(()=> {
            window.ll = new LazyLoad({
              elements_selector: ".e-usebob-lazyload",
              threshold: 0
            });
          }, 200)
        }

        getInstagramItems(_token,25);
      },
      init : function() {
        this.addToCart();
    		this.feedInsta();
      },
    },
    
    mounted: function () {
        return this.methods.init();
    },
};


$(document).ready(function () {
    customMain.mounted();
});

/* NEW PRODUCT PAGE */
$(document).ready(function(){ 
    
    if(window.location.pathname.includes('products')) {

      $('.tab-head').click(function(){  
        $(".tabbody").removeClass('tab-active');
        $(".tabbody[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");
        $(".tab-head").removeClass('active-head');
        $(this).parent().find(".tab-head").addClass('active-head');
      });

      $('.tab-head-use').click(function(){  
        $(".tabbody").removeClass('tab-active-use');
        $(".tabbody[data-id-use='"+$(this).attr('data-id-use')+"']").addClass("tab-active-use");
        $(".tab-head-use").removeClass('active-head-use');
        $(this).parent().find(".tab-head-use").addClass('active-head-use');
      });

    }
  
    $('.ingredients-link a').click(function(e){  
      e.preventDefault();
      var id = $(this).attr('data-ingredient-id');
      $(".pro-ingredient-popup."+id).addClass("active");
      $(".ingredient-overlay").addClass("active");
      $("body").addClass("ingredients-active");
      $(".accordion").removeClass("hide");
      $(".tab-title").removeClass("hide");
    });
    $('.ingredient-overlay, .close-icon').click(function(){  
      $(".pro-ingredient-popup").removeClass("active");
      $(".ingredient-overlay").removeClass("active");
      $("body").removeClass("ingredients-active");
    });
  
    $(".toggle").click(function(e){
      e.preventDefault();
      if ( $(this).closest('li').hasClass('active')){
        $("li").removeClass("active");
        $("li .accordion-details").slideUp(300);			
      } else {
        $("li").removeClass("active");
        $(this).closest('li').addClass('active'); 
        $("li .accordion-details").slideUp(300);		
        $("li.active .accordion-details").slideToggle(300);
      }
    });
  

    /* New Frequency Selector  */
    var fakeRechargeFrequencySelector = $('#delivery-option');
    
    fakeRechargeFrequencySelector.on('change',function(){
        var realRechargeFrequencySelector = $('[name="properties[shipping_interval_frequency]"]');
        var selectedValue = $(this).val();
        realRechargeFrequencySelector.val(selectedValue).trigger('change');
    });

    /* Rechage & One time purchase toggle  */
    $(document).on('click touchstart', '.new-layout .recharge-toggle__button .toggle_btn', function(e){
        //console.log('clicked ', $(this))
       	
        e.stopPropagation();

        $recharge_option = $('.new-layout .recharge-delivery--option');
        
        $productprice = $('.new-layout #ProductPrice_normal');
        $productprice_discount = $('.new-layout #ProductPrice_discount');
        var realRechargeOneTime = $('#rc_container input.rc_radio__onetime');
        var realRechargeAutoDeliver = $('#rc_container input.rc_radio__autodeliver');

        $('.recharge-toggle__button .rc_block__type').each(function(){
            $(this).removeClass('rc_block__type--active');
            $(this).removeClass('active');
            
        })
               
        const btnBuy = document.querySelector("[data-action='add-to-cart']");
        
        if($(this).hasClass('rc_label__onetime')) {
          	btnBuy.innerHTML = "comprar · " + `<span class="btn-price change_price"></span>`;	
            const changePrice = document.querySelector("#rc_price_onetimes").textContent;
          	const spanBuy = document.querySelector(".btn-price.change_price");
            spanBuy.textContent = changePrice;
          
            realRechargeOneTime.click();
            $('#onetime-check').prop('checked', true);
            $('.recharge-toggle__button .rc_block__type__onetime').addClass('rc_block__type--active active');
            $( "#autodeliver-qty-input" ).prop( "disabled", true );
            $( "#onetime-qty-input" ).prop( "disabled", false );
        }else {
          	
          	btnBuy.innerHTML = "assinar · " + `<span class="btn-price change_price"></span>`;
            const changePrice = document.querySelector(".one-autodeliver-right-col span.change_price").textContent;
          	const spanBuy = document.querySelector(".btn-price.change_price");
            spanBuy.textContent = changePrice;
          
            realRechargeAutoDeliver.click();
            $('#subscription-check').prop('checked', true);
            $('.recharge-toggle__button .rc_block__type__autodeliver').addClass('rc_block__type--active active');
            $( "#autodeliver-qty-input" ).prop( "disabled", false );
            $( "#onetime-qty-input" ).prop( "disabled", true );
        }
    });

    $('body').on('click', '.new-layout .adjusts', function(e){

        e.stopPropagation();
        e.preventDefault();
        //console.log('quanitty adjust')
        var ip = parseInt($(this).parent().find('input').val());
        var ips = parseInt($(this).parent().find('input').attr('data_qty'));
        if($(this).hasClass('plus')) {
          ip = ip + 1;
          if((ip > ips)) {
            return false;
          }	
        } else {
          ip = ip - 1;
        }
        if(ip==0) {
          ip = 1;
        }
        var realRechargeFrequencySelector = $('[name="properties[shipping_interval_frequency]"]');
        $(this).parent().find('input').val(ip);
        realRechargeFrequencySelector.val(ip).trigger('change');
      });

        $slick_slider = $('.e-product__photos--large');
        settings_slider = {
            dots: true,
            arrows: false
            // more settings
        }
        slick_on_mobile( $slick_slider, settings_slider);
        
        // slick on mobile
        function slick_on_mobile(slider, settings){
            $(window).on('load resize', function() {
            if ($(window).width() > 767) {
                if (slider.hasClass('slick-initialized')) {
                slider.slick('unslick');
                }
                return
            }
            if (!slider.hasClass('slick-initialized')) {
                return slider.slick(settings);
            }
            });
        };

    // Checkout Button Click
    $(document).on('click touchstart', '.minicart__checkout_btn', function(e) {
        // e.preventDefault();

        return;
        let hasSubscription = false;

        $.getJSON('/cart.js', function(cart) {
            $.each(cart.items, function(index, cartItem) {
                if (cartItem.properties != null && cartItem.properties['shipping_interval_frequency'] != null && typeof(cartItem.properties['shipping_interval_frequency']) !== 'undefined') {
                    hasSubscription = true;
                }
            });
            if (hasSubscription) {
                checkoutUrl = reChargeProcessCart();
                window.location.href = checkoutUrl;
            } else {
                goYampi();
            }
        })
    })
});

  
if(window.location.pathname.includes('products')) {
  
  $(function() {
    $('.pro-rowcol-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: false,
      dots: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 767,
          settings: 'unslick'
        }
      ]
    });
    $(window).on('resize', function() {
      $('.pro-rowcol-slider').slick('resize');
    });
  
    if ( $(window).width() < 768 ) {
      $(".pro-how-use-head a.tab-head-use").click(function(){
        $('.pro-rowcol-slider').slick('refresh');
      });
    }
  });
  
}


$(function() {
    $('body').on('click','.new-layout .e-btn-add-to-cart .Button',function(e){
        e.preventDefault();
        // console.log('hello');
        var btn = $(this);
        var form = $(this).closest('form');
        //console.log("Form acionado", form)
    
        btn.attr('disabled', 'disabled');
        form.find('.error').remove();
        document.dispatchEvent(new CustomEvent("theme:loading:start"))
    
        var data = form.serialize();
        var qtda_product = $('.option-qty-wrapper.enable').val();
        //console.log('form data', form.serialize());
        // console.log('qtda_product', qtda_product);

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data:data,
          dataType: 'json',
          error: function(jqXHR, textStatus, errorThrown){
            var response = $.parseJSON(jqXHR.responseText);
            form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
            btn.removeAttr('disabled');
          }
        }).done(function( response ) {
          btn.removeAttr('disabled');
          document.dispatchEvent(new CustomEvent("theme:loading:end"))
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: response,
              quantity: parseInt(qtda_product)
            }
          }))
        });
        document.dispatchEvent(new CustomEvent("theme:loading:end"))
    
    });
})


// Redirect to the recharge checkout page
function reChargeProcessCart() {
	function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
	do {
      		token=get_cookie('cart');
	}
	while(token == undefined);	var myshopify_domain='rawpack-bars.myshopify.com'
	try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
	var checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker;
  return checkout_url;
}


/* Polling to check if Announcement bar is loaded */
var waitForEl = function (selector, callback, maxTimes = false) {
  //console.log("#rc_container visivel", jQuery('#rc_container').is(":visible"))
if (jQuery(selector).is(":visible")) {
    callback();
} else {
  	//console.log("maxTimes", maxTimes)
    if (maxTimes === false || maxTimes > 0) {
    //console.log("Exec");
    (maxTimes != false) && maxTimes-- ;
    setTimeout(function () {
        waitForEl(selector, callback, maxTimes);
    }, 500); // 200
    }
}
};


waitForEl('#rc_container', function() {  
    $("#recharge__toggle-wrapper").show();
    $("#rc_container").hide();
}, 500); // 100

/* Polling to check if Announcement bar is loaded  End*/

var reviewStars = {
    methods: {
        elements: function() {
            // console.log("oi");

            var products = Array.from(document.querySelectorAll('[data-product-review="0"]'));

            // console.log(products);

            if (products.length >= 1) {
              
                products.forEach(function(product) {
                    
                    if (product.children && Array.from(product.children)[0].dataset.rating) {
                        // console.log(Array.from(product.children)[1]);
                        // console.log(Array.from(product.children)[0]);
                        // console.log(Array.from(product.children)[0].dataset.rating);
                        // console.log(Number(Array.from(product.children)[0].dataset.rating).toFixed(1).replace(".", ","));
                        var rating = Number(Array.from(product.children)[0].dataset.rating).toFixed(1).replace(".", ",");

                        if(rating != "0,0") {
                            Array.from(product.children)[1].classList.add("active");
                            Array.from(product.children)[1].children[1].textContent = rating;    
                        }

                        product.setAttribute("data-product-review", "1");
                    }
                })
            }
            else {
                // console.log("Não tem elemento rating");
            }

          }
    },
    init: function() {
        setInterval(function() {
            reviewStars.methods.elements();
        }, 4000);
    }
}

// reviewStars.init();

var variantProducts = {

  methods: {

      handleVariants() {

          var productItems = Array.from(document.querySelectorAll(".ProductItem[data-js^='product-']"));

          productItems.forEach(function(item) {
            
            var btnBuy = item.querySelector("[data-js='btns-buy']");
            if(!btnBuy) { return };

            // console.log("aqui tem que ter 2: ", btnBuy.children);

            if(btnBuy.children.length !== 2) { return }
      
            var buttons = btnBuy.children[0];
            var variants = btnBuy.children[1];

            var buttonBuy = buttons.children[1];
            var ulVariants = variants.children[0];
            // console.log(buttons.children);
            // console.log(ulVariants.children);
            
            var lisVariants = Array.from(ulVariants.children);

            lisVariants.forEach(function(itemVariant) {
              var inputVariant = itemVariant.children[0];
        
              inputVariant.addEventListener("change", function(e) {
      
                var currentChange = e.target;
                var variantID = currentChange.dataset.variantId;
                var productID = currentChange.dataset.productId;
                var productImage = currentChange.dataset.imageVariant;
                var variantPrice = currentChange.dataset.price;
                var variantComparePrice = currentChange.dataset.comparePrice;
                var variantCardPayment = (Number(variantPrice.replace(",", ".")) / 3).toFixed(2);
                // console.log(variantID)
                
                // console.log(buttonBuy);
                // console.log(buttonBuy.dataset);
                buttonBuy.dataset.id = variantID;

                // console.log(item);
                var elementProductImage = item.querySelector('[data-js="product-'+ productID + '"] .ProductItem__Image')
                var containerPriceList = item.querySelector('[data-js="product-'+ productID + '"] .ProductItem__PriceList')
                // console.log(elementProductImage, containerPriceList)

                if(elementProductImage) {
                  elementProductImage.setAttribute("srcset", productImage);
                  // elementProductImage.srcset = productImage;
                }

                if(containerPriceList) {
                  var contentComparePrice = item.querySelector('[data-js="product-'+ productID + '"] .ProductItem__PriceList .Price--compareAt');
                  var contentPrice = item.querySelector('[data-js="product-'+ productID + '"] .ProductItem__PriceList .Price--highlight');
                  var contentCardPayment = item.querySelector('[data-js="product-'+ productID + '"] .ProductItem__PriceList .e-card-payment');

                  contentPrice.textContent = "$ " + variantPrice;
                  contentCardPayment.textContent = "ou 3x de $ " + variantCardPayment;

                  if(contentComparePrice) {
                    contentComparePrice.textContent = "$ " + String(variantComparePrice).replace(".", ",");
                  }
                  
                }
      
              })
            })

          });


          // var containersBtnBuy = Array.from(document.querySelectorAll("[data-js='btns-buy']"));

          // containersBtnBuy.forEach(function(btnBuy) {
      
          //     // console.log(btnBuy.children[0])
          //     // console.log(btnBuy.children[1])
        
          //     var buttons = btnBuy.children[0];
          //     var variants = btnBuy.children[1];

          //     if(!variants) {
          //         return;
          //     }
        
          //     var buttonBuy = buttons.children[1];
          //     var ulVariants = variants.children[0];
          //     // console.log(buttons.children[1])
          //     // console.log(ulVariants.children[0])
              
          //     var lisVariants = Array.from(ulVariants.children);
        
          //     lisVariants.forEach(function(itemVariant) {
        
          //         var inputVariant = itemVariant.children[0];
          
          //         inputVariant.addEventListener("change", function(e) {
          
          //           var currentChange = e.target;
          //           var variantID = currentChange.dataset.variantId;
          //           var productID = currentChange.dataset.productId;
          //           var productImage = currentChange.dataset.imageVariant;
          //           var variantPrice = currentChange.dataset.price;
          //           var variantComparePrice = currentChange.dataset.comparePrice;
          //           var variantCardPayment = (Number(variantPrice.replace(",", ".")) / 3).toFixed(2);
          //           // console.log(variantID)
                    
          //           buttonBuy.dataset.id = variantID;

          //           var elementProductImage = document.querySelector('[data-js="product-'+ productID + '"] .ProductItem__Image')
          //           var containerPriceList = document.querySelector('[data-js="product-'+ productID + '"] .ProductItem__PriceList')
          //           // console.log(elementProductImage, containerPriceList)

          //           if(elementProductImage) {
          //             elementProductImage.setAttribute("srcset", productImage);
          //             // elementProductImage.srcset = productImage;
          //           }

          //           if(containerPriceList) {
          //             var contentComparePrice = document.querySelector('[data-js="product-'+ productID + '"] .ProductItem__PriceList .Price--compareAt');
          //             var contentPrice = document.querySelector('[data-js="product-'+ productID + '"] .ProductItem__PriceList .Price--highlight');
          //             var contentCardPayment = document.querySelector('[data-js="product-'+ productID + '"] .ProductItem__PriceList .e-card-payment');

          //             contentPrice.textContent = "$ " + variantPrice;
          //             contentCardPayment.textContent = "ou 3x de $ " + variantCardPayment;

          //             if(contentComparePrice) {
          //               contentComparePrice.textContent = "$ " + String(variantComparePrice).replace(".", ",");
          //             }
                      
          //           }
          
          //         })
          //     })
          // })
      }
  },

  init: function() {

      this.methods.handleVariants();
  }
}

variantProducts.init();


// console.log(document.querySelectorAll(".e-usebob-lazyload"));

// LAZYLOAD NO SITE
window.ll = new LazyLoad({
  elements_selector: ".e-usebob-lazyload",
  threshold: 0
});


if($('[data-js="countdown"]').length > 0) {

  $('[data-js="countdown"]').each(function(count) {
  
    // console.log($(this).attr("data-tempo-promo"));
  
    const tempoPromo = $(this).attr("data-tempo-promo");
    const tempoInicio = $(this).attr("data-tempo-inicio");
  
    const [hour, minutes, seconds] = tempoPromo.split(":");
    const [hourIni, minutesIni, secondsIni] = tempoInicio.split(":");
    const dataInicio = new Date();
  
    dataInicio.setHours(hourIni, minutesIni, secondsIni);
    // console.log(dataInicio);
    // console.log(dataInicio.getTime());
    
    const today = new Date();
  
    // console.log($(this).parent());
    // console.log($(this).parent().next());
    
    if(today.getTime() > dataInicio.getTime()) {
  
      $(this).parent().next().show();
  
      // console.log(hourIni, minutesIni, secondsIni);
      dataInicio.setHours(Number(hourIni) + Number(hour), Number(minutesIni) + Number(minutes), Number(secondsIni) + Number(seconds));
      // console.log(dataInicio);
    
      $(this).countdown(dataInicio)
        .on('update.countdown', function(event) {
          var format = '%H:%M:%S';
          $(this).html(event.strftime(format));
        })
        .on('finish.countdown', function(event) {
          $(this).html('');
          $(this).parent().next().remove();
        });
    }
    else {
      $(this).parent().next().hide();
    }
  
  })
}


if(document.querySelector("a.e-product-item-star") && document.querySelector(".e-product-reviews-default")) {

  $(document).on('click', 'a.e-product-item-star', function (e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $('.e-product-reviews-default').offset().top - 20
    }, 'slow');
  });
}


function handleAddCartItemStamped() {

  const slides = Array.from(document.querySelectorAll('.stamped-instagram-media-block'));
  // console.log(slides);
  if(slides.length == 0) { return }

  slides.forEach(function(slide) {
    slide.addEventListener("click", function() { addHandleClickProduct() });
  })

  function addHandleClickProduct() {

    const btnsAddCart = Array.from(document.querySelectorAll(".stamped-ugc-modal.open .stamped-ugc-modal-tags-btn"));
    // console.log(btnsAddCart);
    if(btnsAddCart.length == 0) { return }

    btnsAddCart.forEach(function(btn) {
    
      btn.addEventListener("click", function() {
        const action = { bubbles: true, detail: { quantity: 1 } };

        setTimeout(function() {
          document.dispatchEvent(new CustomEvent('product:added', action));
        }, 1500)

      });
  
    })
  }
}

window.addEventListener("load", function() {
  setTimeout(function() { handleAddCartItemStamped() }, 2000)
  handleChallenger();
})


// PROMOCODE
function handlePromoCode() {

  const path = window.location.search;
  const isExistParams = path.includes("?");
  const isMultipleParams = path.includes("&");

  if(isExistParams && isMultipleParams) {
      const params = path.split('&');
      // const isExistCupom = params.find(function(param) { return param.includes("promocode") });
      const isExistCupom = params.find(function(param) { return param.toLowerCase().includes("utm_source") });

      if(!isExistCupom) {
        // console.log("Não tem promocode na URL");
        return 
      };

      const [key, value] = isExistCupom.split("=");
      const isExistCookie = getCookiePromo(key);

      setCookiePromo('promocode', value);
      // console.log("Cupom no cookies atualizado");

  }
  else if(isExistParams) {

      const param = path.slice(1).split(' ');
      // const isExistCupom = param.find(function(par) { return par.includes("promocode") });
      const isExistCupom = param.find(function(par) { return par.toLowerCase().includes("utm_source") });

      if(!isExistCupom) {
        // console.log("Não tem promocode na URL");
        return 
      };

      const [key, value] = isExistCupom.split("=");
      const isExistCookie = getCookiePromo(key);

      setCookiePromo('promocode', value);
      // console.log("Cupom no cookies atualizado");

  }
  else {
      // console.log("Não tem paramêtros na URL");
  }

  function setCookiePromo(keyCookie, valueCookie) {

      const today = new Date();
      // today.setMinutes(today.getMinutes() + 30);
      today.setDate(today.getDate() + 7);

      const day = {
          0: 'Sun',
          1: 'Mon',
          2: 'Tue',
          3: 'Wed',
          4: 'Thu',
          5: 'Fri',
          6: 'Sat'
      }

      const month = {
          0: 'Jan',
          1: 'Feb',
          2: 'Mar',
          3: 'Apr',
          4: 'May',
          5: 'Jun',
          6: 'Jul',
          7: 'Aug',
          8: 'Sep',
          9: 'Oct',
          10: 'Nov',
          11: 'Dez',
      }

      const cookie = `${keyCookie}=${valueCookie}; path=/; expires=${today.toUTCString()}`;
      // console.log(cookie);
      document.cookie = cookie;
  }

  function getCookiePromo(keyCookie) {
      const currentArrayCookies = document.cookie.split('; ')
      
      const temCookie = currentArrayCookies.find(cookie => cookie.startsWith(keyCookie))
      
      if(temCookie) {
          const cookie = temCookie.split('=');
          return cookie;
      }
      else {
          return false;
      }
      
  }

}

handlePromoCode();

function handleChallenger() {

  const path = window.location.pathname;

  if(path === '/challenge') {
    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
  }
}